import React from 'react';

export default function ServiceCard({ icono, titulo, descripcion }) {
  return (
    <div className="group p-8 rounded-2xl border border-stone-200 hover:border-teal-300 hover:bg-teal-50/50 transition-all duration-300">
      <div className="text-3xl mb-4">{icono}</div>
      <h3 className="font-display text-xl text-stone-800 mb-3">{titulo}</h3>
      <p className="text-stone-500 text-sm leading-relaxed">{descripcion}</p>
    </div>
  );
}